export const ADDRESS_SELECT_MAX_LENGTH = 500
